<template>
  <div class="inner-main">
    <div class="my-tag">数据来源:工商信息</div>
    <div class="item"
      v-for="(item,idx) in dataList"
      :key="idx">
      <div class="left">
        <div class="name">{{item.name}}</div>
        <div class="type">{{item.type}}</div>
      </div>
      <div class="right">
        <div v-if="item.rate!=null"
          class="rate">{{item.rate}}</div>
        <div v-if="item.rate==null">持股比例</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  props: {
    dataList: {
      type: Array,
      required: false,
    },
  },
  components: {},

  computed: {},

  mounted () { },

  methods: {},
};
</script>
<style lang='less' scoped>
.inner-main {
  padding: 1.125rem;
}

.weight {
  font-weight: 600;
  color: #464646;
}
.title {
  font-weight: 600;
  font-size: 20px;
  // margin-top: 12px;
  color: #464646;
}
.item {
  display: flex;
  margin-bottom: 10px;
  margin-top: 1rem;

  .left {
    flex: 1;
    width: 15rem;

    .name {
      .weight();
    }
  }

  .right {
    .rate {
      .weight();
    }
    width: 5rem;
    text-align: right;
    // margin-top: 1.8rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/content/invested/Gongshang.vue